// extracted by mini-css-extract-plugin
export default {"sectionBackground":"ProviderTypesSection_sectionBackground__PiEw+","footfallLogo":"ProviderTypesSection_footfallLogo__bbQwX","image":"ProviderTypesSection_image__ejf7D"};